import { initialObjTransactionsType } from 'components/tables/TransactionsTable/ViewsForm/data';
import { KeyTransactions } from 'components/tables/TransactionsTable/data';

const initialIncomingRequiredKey = [
  KeyTransactions.TYPE,
  KeyTransactions.VALUE_DATE_TIME,
  KeyTransactions.TRANSACTION_DATE,
  KeyTransactions.CURRENCY,
  KeyTransactions.AMOUNT,
  KeyTransactions.RECIPIENT,
  KeyTransactions.REFERENCE,
  KeyTransactions.DETAILS,
  KeyTransactions.COMMENT,
];

export const requiredIncomingKeys = (transactionsFormData: initialObjTransactionsType) => {
  if (!transactionsFormData.checkbox) {
    return [...initialIncomingRequiredKey, KeyTransactions.SENDER];
  }

  return initialIncomingRequiredKey;
};

export const errorsIncoming = {
  [KeyTransactions.ROOT]: [
    { key: KeyTransactions.VALUE_DATE_TIME, parameters: { required: true } },
    { key: KeyTransactions.TRANSACTION_DATE, parameters: { required: false } },
    { key: KeyTransactions.TYPE, parameters: { required: true } },
    { key: KeyTransactions.CURRENCY, parameters: { required: true } },
    { key: KeyTransactions.AMOUNT, parameters: { required: true } },
    { key: KeyTransactions.RECIPIENT, parameters: { required: true } },
    { key: KeyTransactions.SENDER, parameters: { required: true } },
  ],
};

export type errorsIncomingType = typeof errorsIncoming;
